import { BaseService } from '@/modules/Core/services/BaseService' // Asegúrate de tener la interfaz definida
import type { ICitaAdmision } from '@/modules/Admision/interfaces'
import type { AxiosResponse } from 'axios'
import type { IResponseApi, IResponseApiSearch } from '@/modules/Core/interfaces'
import type { tipoEstadisticaAdmisiones, tipoGeneralesAdmisiones } from '@/modules/Admision/interfaces'
import type { ICitaTechnologiasSalud } from '@/modules/Asistencial/interfaces'
import type { tipoGeneralesAdmisionesIndex } from '../interfaces/tablas/ICitaAdmision'
export class AdmisionService extends BaseService<ICitaAdmision> {
  constructor() {
    super({
      baseUrl: 'scheduling/admissions/'
    })
  }
  async getAdmisionByTechId(
    id: number,
    params?: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApi<ICitaAdmision>>> {
    return this.http
      .get<ICitaAdmision>(`/get-adm-by-tech-id/${id}`, { params })
      .catch(this.errorHandle)
  }
  async getUltimoContrato(
    id: number
  ): Promise<AxiosResponse<IResponseApi<ICitaAdmision>>> {
    return this.http.get<IResponseApi<ICitaAdmision>>(
      `/get-last-contract/${id}`
    )
  }
  async getGenerales(
    params?: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApi<tipoGeneralesAdmisiones>>> {
    return this.http.get<IResponseApi<tipoGeneralesAdmisiones>>(`/general`, {
      params
    })
  }
  async getGeneralesIndex(
    params?: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApi<tipoGeneralesAdmisionesIndex>>> {
    return this.http.get<IResponseApi<tipoGeneralesAdmisionesIndex>>(`/general-index`, {
      params
    })
  }
  
  async finishTech(
    id: number,
    params?: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApi<ICitaAdmision>>> {
    return this.http
      .put<ICitaAdmision>(`/finish-tech/${id}`, { params })
      .catch(this.errorHandle)
  }
  async getEstadisticas(
    params?: Record<string, unknown>
  ): Promise<
    AxiosResponse<
      IResponseApi<{
        estadisticas: tipoEstadisticaAdmisiones[]
        estadisticasporservicio: tipoEstadisticaAdmisiones[]
      }>
    >
  > {
    return this.http.get<
      IResponseApi<{
        estadisticas: tipoEstadisticaAdmisiones[]
        estadisticasporservicio: tipoEstadisticaAdmisiones[]
      }>
    >(`/statistics`, { params })
  }
  async updateByAgenda(
    ciag_id: number,
    data: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApi<ICitaAdmision>>> {
    return this.http
      .put<ICitaAdmision>(`/update-by-agenda/${ciag_id}`, data)
      .catch(this.errorHandle)
  }
  async updateTechById(
    cittId: number,
    data: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApi<boolean>>> {
    return this.http
      .put<boolean>(`/update-technologi/${cittId}`, data)
      .catch(this.errorHandle)
  }
  async getInvoicesitems(
    ciadId: number
  ): Promise<AxiosResponse<IResponseApiSearch<unknown[]>>> {
    return this.http
      .get<IResponseApiSearch<unknown[]>>(`/invoices-items/${ciadId}`)
      .catch(this.errorHandle)
  }
  async updateFromAuditoriaFinanciera(
    ciadId: number,
    data: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApi<ICitaAdmision>>> {
    return this.http
      .put<ICitaAdmision>(`/update/${ciadId}`, data, {
        params: { origen: 'auditoria-financiera' }
      })
      .catch(this.errorHandle)
  }
  async getHistorialVacunas(
    copeId: number
  ): Promise<AxiosResponse<IResponseApi<ICitaTechnologiasSalud[]>>> {
    return this.http
      .get<boolean>(`getHistorialVacunas/${copeId}`)
      .catch(this.errorHandle)
  }
  async putCierreMasivoAtenciones(data: Record<string, unknown>): Promise<AxiosResponse<IResponseApi<ICitaTechnologiasSalud[]>>> {
    return this.http
      .put<ICitaAdmision>(`massive-closure/`, data)
      .catch(this.errorHandle)
  }
  async putRevertirCierreMasivoAtenciones(data: Record<string, unknown>): Promise<AxiosResponse<IResponseApi<ICitaTechnologiasSalud[]>>> {
    return this.http
      .put<ICitaAdmision>(`reverse-massive-closure/`, data)
      .catch(this.errorHandle)
  }
  async putInasistirMasivoAtenciones(data: Record<string, unknown>): Promise<AxiosResponse<IResponseApi<ICitaTechnologiasSalud[]>>> {
    return this.http
      .put<ICitaAdmision>(`massive-noattendance/`, data)
      .catch(this.errorHandle)
  }
}
